/**
 * patrol-tracking-view.js
 */

import React from 'react';
import { format, parseISO } from 'date-fns';
import { displayNumber } from 'utils/misc';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import { DeploymentMap } from 'components/tracking/map/viewing-map';
import PatrolArrestsBites from '../../helpers/patrol-arrests-bites-view';


export default function PatrolTrackingView(props) {
  const { 
    deployment,
    deploymentId,
    record,
  } = props;


  return (
    <>      
      <IconSection iconName='patrol-tracking'>

        {/* terrain types */}
        <InfoRow 
          title='Terrain Types' 
          text={record.tracking.terrainTypes.map(type => type.customOtherName || type.name).join(', ')} 
        />
          
        {/* obstruction types */}
        {record.tracking.obstructionTypes?.length > 0 &&
        <InfoRow 
          title='Obstruction Types' 
          text={record.tracking.obstructionTypes.map(type => type.customOtherName || type.name).join(', ')} 
        />}

        {/* distance */}
        {record.tracking.trackDistance !== null &&
        <InfoRow 
          title="Track Distance" 
          text={`${displayNumber(record.tracking.trackDistance)} ${record.tracking.trackDistanceUnit?.name}`}
        />}

        {/* duration */}
        <InfoRow 
          title='Track Duration' 
          text={`${record.tracking.trackDuration || 0} minute${record.tracking.trackDuration === 1 ? '' : 's'}`} 
        />

        {/* total turns */}
        {record.tracking.trackTotalTurns !== undefined && record.tracking.trackTotalTurns !== null &&
        <InfoRow 
          title="Track Turns" 
          text={record.tracking.trackTotalTurns} 
        />}

        {/* track laid time */}
        {record.tracking.trackLaidTime && 
        <InfoRow 
          title="Track Laid Time" 
          text={format(parseISO(record.tracking.trackLaidTime), 'h:mm aaa')}
        />}

        {/* track followed time */}
        {record.tracking.trackFollowedTime && 
        <InfoRow 
          title="Track Followed Time" 
          text={format(parseISO(record.tracking.trackFollowedTime), 'h:mm aaa')}
        />}

        {/* human crossings */}
        {record.tracking.trackTotalHumansCrossing !== null &&
        <InfoRow 
          title="Number of Human Crossings" 
          text={record.tracking.trackTotalHumansCrossing} 
        />}

        {/* animals on track */}
        {record.tracking.trackTotalAnimalsOnTrack !== null &&
        <InfoRow 
          title="Number of Animals on Track" 
          text={record.tracking.trackTotalAnimalsOnTrack} 
        />}

      </IconSection>

      <DeploymentMap
        recordId={deploymentId}
        trackingRecord={record.tracking}
      />

      <PatrolArrestsBites 
        deployment={deployment}
        record={record}
      />
    </>
  );
}